import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "output", "checkbox", "hidden"]

  connect() {
    this.updateAll()
    this.toggleAllActive()
  }

  update(event) {
    const slider = event?.target || this.sliderTarget
    const container = slider.closest('.d-flex')
    const output = container.querySelector('[data-range-slider-target="output"]')
    if (output) {
      output.textContent = slider.value
    }
  }

  updateAll() {
    this.sliderTargets.forEach(slider => {
      const container = slider.closest('.d-flex')
      const output = container.querySelector('[data-range-slider-target="output"]')
      if (output) {
        output.textContent = slider.value
      }
    })
  }

  toggleActive(event) {
    const checkbox = event.target
    const container = checkbox.closest('.d-flex')
    const slider = container.querySelector('[data-range-slider-target="slider"]')
    const hidden = container.querySelector('[data-range-slider-target="hidden"]')
    const output = container.querySelector('[data-range-slider-target="output"]')
    
    if (checkbox.checked) {
      slider.disabled = false
      hidden.disabled = true
      if (output) {
        output.textContent = slider.value
      }
    } else {
      slider.disabled = true
      hidden.disabled = false
      if (output) {
        output.textContent = "—"
      }
    }
  }

  toggleAllActive() {
    this.checkboxTargets.forEach(checkbox => {
      const event = { target: checkbox }
      this.toggleActive(event)
    })
  }
} 